import { quSave } from '@/service/question'
import util from '@/tools/commonUtil'
import iconSrc from '@/assets/images/edit/config/m-lef-slider@2x.png'
export default {
  orderById: 80,
  elementType: 'RateBox',
  elementDesc: '滑块题',
  type: 'ratebox',
  // 是否可配置
  config: true,
  title: '滑块题',
  placeholder: '滑块题',
  isRequired: '1',
  // 当为100段时起点滑块位置
  scoreQuInitial: '1',
  // 最小分
  paramInt01: '1',
  // 最大分
  paramInt02: '5',
  // 分数题 题目类型1利克特量表2星形3双极量表4滑块5正好尺度
  scoreQuType: '1',
  // 分数题  段位
  scoreQuParagraph: '5',
  itemKey: 'optionList',
  // 选项vo
  optionList: [],
  tmpValue: 1,
  value: null,
  ruleError: '该字段不能为空',
  toolbar: {
    config: false
  },
  saveUrl: '/design/qu-score/ajaxSave.do',
  iconStyle: {
    width: '12px',
    height: '11px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
      paramInt01: this.paramInt01,
      paramInt02: this.paramInt02,
      scoreQuType: this.scoreQuType,
      scoreQuParagraph: this.scoreQuParagraph,
      optionList: util.genList(this.optionList)
    }, this)
  },
  saveCb (data) {
    this.scoreQuInitial = data.scoreQuInitial
    if (this.scoreQuInitial && data.paramInt02 === '100') {
      this.tmpValue = this.scoreQuInitial
      this.paramInt01 = this.scoreQuInitial
    }
    this.paramInt02 = data.paramInt02
    this.optionList = util.genRetList.call(this, data.optionList, 'option')
    this.scoreQuType = data.scoreQuType
    this.scoreQuParagraph = data.scoreQuParagraph
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      answserScore: this.value
    })
    return answer
  },
  getScoreQuParagraphList () {
    return RATE_CONFIG_MAPP[this.scoreQuType].scoreQuParagraphList
  },
  onScoreQuTypeChg (scoreQuType) {
    const {scoreQuParagraph, paramInt01, paramInt02} = RATE_CONFIG_MAPP[scoreQuType]
    this.scoreQuParagraph = scoreQuParagraph
    this.paramInt01 = paramInt01
    this.paramInt02 = paramInt02
    this.tmpValue = 1
    // this.value = 1
    this.onScoreQuParagraphChg()
  },
  onScoreQuParagraphChg () {
    const rateConfig = RATE_CONFIG_MAPP[this.scoreQuType]
    const scoreQuParagraphList = rateConfig.scoreQuParagraphList
    const scoreQuParagraph = this.scoreQuParagraph
    if (scoreQuParagraphList) {
      this.paramInt02 = scoreQuParagraphList.filter(item => item.optionName === scoreQuParagraph)[0].paramInt02
    }
    const optionListMapp = rateConfig.optionListMapp[scoreQuParagraph]
    let optionList = []
    optionListMapp.forEach(({optionTitle, optionName}, index) => {
      optionList.push({
        quId: '',
        optionTitle,
        optionName,
        orderById: index + 1 + '',
        visibility: '1'
      })
    })
    this.optionList = optionList
  }
}

const RATE_CONFIG_MAPP = {
  '1': {
    scoreQuParagraph: '5',
    scoreQuParagraphList: [
      {optionTitle: '4项', optionName: '4', paramInt02: '4'},
      {optionTitle: '5项', optionName: '5', paramInt02: '5'},
      {optionTitle: '6项', optionName: '6', paramInt02: '6'},
      {optionTitle: '7项', optionName: '7', paramInt02: '7'}
    ],
    optionList: [],
    optionListMapp: {
      '4': [
        {optionTitle: '非常符合', optionName: '1'},
        {optionTitle: '符合', optionName: '2'},
        {optionTitle: '不太符合', optionName: '3'},
        {optionTitle: '完全不符合', optionName: '4'}
      ],
      '5': [
        {optionTitle: '非常符合', optionName: '1'},
        {optionTitle: '符合', optionName: '2'},
        {optionTitle: '不确定', optionName: '3'},
        {optionTitle: '不太符合', optionName: '4'},
        {optionTitle: '完全不符合', optionName: '5'}
      ],
      '6': [
        {optionTitle: '完全符合', optionName: '1'},
        {optionTitle: '符合', optionName: '2'},
        {optionTitle: '有点符合', optionName: '3'},
        {optionTitle: '有点不符合', optionName: '4'},
        { optionTitle: '不符合', optionName: '5' },
        {optionTitle: '完全不符合', optionName: '6'}
      ],
      '7': [
        {optionTitle: '完全符合', optionName: '1'},
        {optionTitle: '符合', optionName: '2'},
        { optionTitle: '有点符合', optionName: '3' },
        {optionTitle: '不确定', optionName: '4'},
        {optionTitle: '有点不符合', optionName: '5'},
        { optionTitle: '不符合', optionName: '6' },
        {optionTitle: '完全不符合', optionName: '7'}
      ]
    }
  },
  '2': {
    paramInt01: '1',
    paramInt02: '5',
    scoreQuParagraph: '5',
    optionList: [],
    optionListMapp: {
      '5': [
        {optionTitle: '不满意', optionName: '1', paramInt02: '5'},
        {optionTitle: '满意', optionName: '2', paramInt02: '5'}
      ]
    }
  },
  '3': {
    paramInt01: '1',
    paramInt02: '7',
    scoreQuParagraph: '7',
    scoreQuParagraphList: [
      {optionTitle: '5段', optionName: '5', paramInt02: '5'},
      {optionTitle: '7段', optionName: '7', paramInt02: '7'},
      {optionTitle: '11段', optionName: '11', paramInt02: '11'}
    ],
    optionList: [],
    optionListMapp: {
      '5': [
        {optionTitle: '复杂', optionName: '1'},
        {optionTitle: '不确定', optionName: '4'},
        {optionTitle: '简单', optionName: '7'}
      ],
      '7': [
        {optionTitle: '复杂', optionName: '1'},
        {optionTitle: '不确定', optionName: '4'},
        {optionTitle: '简单', optionName: '7'}
      ],
      '11': [
        {optionTitle: '复杂', optionName: '1'},
        {optionTitle: '不确定', optionName: '4'},
        {optionTitle: '简单', optionName: '7'}
      ]
    }
  },
  '4': {
    paramInt01: '1',
    paramInt02: '10',
    scoreQuParagraph: '10',
    scoreQuParagraphList: [
      {optionTitle: '10段', optionName: '10', paramInt02: '10'},
      {optionTitle: '100段', optionName: '100', paramInt02: '100'}
    ],
    optionList: [],
    optionListMapp: {
      '10': [
        {optionTitle: '完全不可能', optionName: '1'},
        {optionTitle: '极有可能', optionName: '10'}
      ],
      '100': [
        {optionTitle: '完全不可能', optionName: '1'},
        {optionTitle: '极有可能', optionName: '100'}
      ]
    }
  },
  '5': {
    paramInt01: '1',
    paramInt02: '10',
    scoreQuParagraph: '5',
    optionList: [],
    optionListMapp: {
      '5': [
        {optionTitle: '太大', optionName: '1'},
        {optionTitle: '有点太大', optionName: '2'},
        {optionTitle: '适中', optionName: '3'},
        {optionTitle: '有点太小', optionName: '4'},
        {optionTitle: '太小', optionName: '5'}
      ]
    }
  },
  '6': {
    paramInt01: '0',
    paramInt02: '10',
    scoreQuParagraph: '10',
    scoreQuParagraphList: [
      {optionTitle: '10段', optionName: '10', paramInt02: '10'},
      {optionTitle: '100段', optionName: '100', paramInt02: '100'}
    ],
    optionList: [],
    optionListMapp: {
      '10': [
        {optionTitle: '完全不可能', optionName: '0'},
        {optionTitle: '极有可能', optionName: '10'}
      ],
      '100': [
        {optionTitle: '完全不可能', optionName: '1'},
        {optionTitle: '极有可能', optionName: '100'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/RateBox/config.js